import { motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { CalendarIcon, ArrowLinkIcon } from './icons';

function NotificationCard({ title, body, style, delay }) {
  return (
    <Reveal
      delay={delay * 3}
      y={20}
      scale={0.95}
      style={{
        position: 'absolute', width: 200, background: '#fff', borderRadius: 17,
        boxShadow: '0 12px 32px rgba(0,0,0,0.18)', padding: '16px 18px', ...style,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <div style={{ width: 28, height: 28, borderRadius: 8, background: '#f0f9f6', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#2ca342" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
        </div>
        <p style={{ margin: 0, fontSize: 13, fontFamily: 'Inter, sans-serif', fontWeight: 700, color: '#000' }}>{title}</p>
      </div>
      <p style={{ margin: 0, fontSize: 12, fontFamily: 'Inter, sans-serif', fontWeight: 500, color: '#4c5876', lineHeight: 1.4 }}>{body}</p>
    </Reveal>
  );
}

export function CtaSection() {
  return (
    <section style={{ maxWidth: 1400, margin: '0 auto', padding: '0 24px 40px' }}>
      <Reveal scale={0.94} y={40}>
        <div
          style={{
            position: 'relative', overflow: 'hidden', borderRadius: 17, minHeight: 400,
            backgroundImage: 'linear-gradient(12.75deg, rgb(35,66,153) 44%, rgb(46,43,75) 82%, rgb(28,41,75) 92%)',
            display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 24,
          }}
        >
          <div style={{ flex: '1 1 420px', minWidth: 300, padding: '56px 48px' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, height: 32, padding: '0 16px', background: 'rgba(240,249,246,0.18)', borderRadius: 23, marginBottom: 24 }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#2ca342', flexShrink: 0 }} />
              <span style={{ fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 500, color: '#fff' }}>Get started today</span>
            </div>
            <h2 style={{ margin: '0 0 20px', fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: 'clamp(26px, 3.2vw, 38px)', color: '#fff', lineHeight: 1.2 }}>
              Start sending in minutes, not hours.
            </h2>
            <p style={{ margin: '0 0 36px', fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: 16, color: '#fff', lineHeight: 1.5, maxWidth: 440 }}>
              Join thousands of businesses already using sleengshort to power their communication.
            </p>
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
              <a href="/login" style={{ textDecoration: 'none' }}>
                <motion.span
                  whileHover={{ opacity: 0.9 }}
                  whileTap={{ scale: 0.97 }}
                  style={{ height: 57, padding: '0 24px', background: '#fff', borderRadius: 7, display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, fontFamily: 'Inter, sans-serif', fontWeight: 600, color: '#014ed2' }}
                >
                  <CalendarIcon color="#014ed2" />
                  Book a Demo
                </motion.span>
              </a>
              <a href="mailto:support@sleengshort.com" style={{ textDecoration: 'none' }}>
                <motion.span
                  whileHover={{ backgroundColor: 'rgba(255,255,255,0.08)' }}
                  whileTap={{ scale: 0.97 }}
                  style={{ height: 51, padding: '0 24px', border: '1px solid #cecece', borderRadius: 7, display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, fontFamily: 'Inter, sans-serif', fontWeight: 600, color: '#fff' }}
                >
                  Talk to Sales
                  <ArrowLinkIcon color="#fff" />
                </motion.span>
              </a>
            </div>
          </div>

          <div style={{ position: 'relative', flex: '1 1 380px', minWidth: 300, height: 420, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ position: 'relative', width: 340, height: 380 }}>
              <img src="/landing/cta-photo.png" alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', borderRadius: 20 }} />
              <NotificationCard title="Promotions" body="Big sale is live. Get up to 50% off on all items." style={{ top: -10, right: -40 }} delay={0.1} />
              <NotificationCard title="Message Sent" body="Your message was delivered successfully." style={{ top: 160, left: -60 }} delay={0.25} />
              <NotificationCard title="New Order" body="You have received a new order #56877." style={{ bottom: -20, right: -30 }} delay={0.4} />
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
